import {
    Modal,
    ModalContent,
    ModalOverlay,
    ModalBody,
    ModalHeader,
    ModalCloseButton,
    Text,
    Flex,
    Image,
    ModalFooter,
    Center
} from '@chakra-ui/react'

function QrCodeModal({ qrCodeImage, isOpen, onClose, name }: any) {
    return (
        <Flex>
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                size={{ base: 'sm', md: 'xl' }}
                motionPreset="slideInBottom"
                scrollBehavior="inside"
            >
                <ModalOverlay backdropFilter="blur(8px)" />
                <ModalContent pb={6} border="2px solid white" alignItems={'center'}>
                    <ModalHeader>Show this QR at the entrance</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Center>
                            <Image
                                border={'1px solid'}
                                borderRadius={4}
                                boxSize={'220px'}
                                src={qrCodeImage != null ? qrCodeImage : ''}
                                alt="child qr code"
                            />
                        </Center>
                    </ModalBody>
                    <ModalFooter>
                        <Center textAlign={'center'}>
                            <Text fontWeight={'bold'}>{`${name} QR Code`}</Text>
                        </Center>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Flex>
    )
}

export default QrCodeModal
